/* global _:false */

export class ValidationRule {
  constructor() {
    // limit usage to argument only
    this.restrict = 'A';

    // require NgModelController, i.e. require a controller of ngModel directive
    this.require = 'ngModel';
  }

  validate(value, regex, rule) {
    // Default validation fails
    let valid = false;

    // Whether to remove whitespaces or don't depends on the specific
    // validation rule and so each rule can set this behaviour individually.
    if (this.ignoreWhitespace) {
      value = value.replace(/\s+/g, '');
    }

    // Support multiple regexes, handle them with an or concatenation
    if (angular.isArray(regex)) {
      // Iterates over all regex, returning the first truthy value for, else undefined.
      valid = _.some(regex, r => this.runTest(r, value));
    }
    else if (this.runTest(regex, value)) {
      // value is valid
      valid = true;
    }

    // Support optional validation rule which has the final say
    if (angular.isFunction(rule)) {
      valid = rule(value, valid);
    }

    return valid;
  }
  
  // Supports test to be a function or a regex
  runTest(test, value) {
    if (angular.isFunction(test)) {
      return test(value);
    }
    return test.test(value);
  }

  validator(ctrl, identifier, regex, rule = null) {
    ctrl.$validators[identifier] = (modelValue, viewValue) => {
      if (ctrl.$isEmpty(modelValue)) {
        // Consider empty models to be valid
        return true;
      }
      return this.validate(viewValue, regex, rule);
    };
  }

  parser(ctrl, identifier, regex, validator) {
    ctrl.$parsers.unshift(value => {
      let valid = ctrl.$isEmpty(value) || this.validate(value, regex, validator);
      ctrl.$setValidity(identifier, valid);

      // Ensure to return the value, to be displayed to the user(value of the input)
      return value;
    });
  }

  formatter(ctrl, identifier, regex, validator) {
    ctrl.$formatters.unshift(value => {
      let valid = ctrl.$isEmpty(value) || this.validate(value, regex, validator);
      ctrl.$setValidity(identifier, valid);
      ctrl.$setTouched();

      // Ensure to return the value, to be displayed to the user(value of the input)
      return value;
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-form-validation/src/validationRule.js